import React from 'react';
import { checkSize, checkColor } from './svg.helper';

export function arrowDownLg(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M3 7a1 1 0 00-.67 1.75l9 8.05c.38.338.95.338 1.33 0l9.044-8.1a.998.998 0 00.042-1.376 1.002 1.002 0 00-1.372-.113L12 14.69 3.66 7.23A.994.994 0 003 7z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}

export function arrowDownSm(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M15.986 9.001a.993.993 0 00-.68.27l-3.32 3.1-3.3-3.1a1.001 1.001 0 00-1.37 1.46l4 3.73a1 1 0 001.37 0l4-3.73a1 1 0 00-.7-1.73z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}

export function arrowLeftLg(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M17.053 20.956a.998.998 0 01-1.75.67l-8.05-9a1.001 1.001 0 010-1.33l8-9a1 1 0 011.49 1.33l-7.37 8.33 7.46 8.34c.15.186.228.42.22.66z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}

export function arrowLeftSm(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M14.731 15.986a.995.995 0 00-.27-.68l-3.09-3.32 3.09-3.3a1.002 1.002 0 10-1.46-1.37l-3.73 4a1.002 1.002 0 000 1.37l3.73 4a1.001 1.001 0 001.73-.7z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}

export function arrowNext(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M8.201 15.985a1 1 0 01.268-.679l3.069-3.314-3.069-3.295a1 1 0 01.499-1.657.992.992 0 01.951.29l3.704 3.993a1 1 0 010 1.367L9.92 16.684a.989.989 0 01-1.097.243.997.997 0 01-.62-.942zM17 7v9.983h-1.986V7H17z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}

export function arrowPrevious(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M15.13 7.33a1.002 1.002 0 011.46 1.37L13.5 12l3.09 3.32c.173.184.27.427.27.68a1 1 0 01-1.73.7l-3.73-4a1 1 0 010-1.37zM10 7v10H8V7h2z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}

export function arrowRightLg(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M7.005 21.02a1.001 1.001 0 001.75.67l8.05-9a.999.999 0 000-1.33l-8-9a1.026 1.026 0 00-1.56 1.33l7.45 8.33-7.46 8.34a1 1 0 00-.23.66z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}

export function arrowRightSm(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M9.001 15.984a.975.975 0 01.283-.68l3.234-3.32-3.234-3.298a.97.97 0 01.047-1.415 1.082 1.082 0 011.48.045l3.905 3.999a.967.967 0 010 1.37l-3.904 3.998a1.082 1.082 0 01-1.157.244 1 1 0 01-.654-.943z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}

export function arrowUpLg(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M3 17a1 1 0 01-.67-1.75l9-8.05a.999.999 0 011.33 0l9 8a1 1 0 01-1.33 1.49L12 9.31l-8.34 7.46A1 1 0 013 17z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}

export function arrowUpSm(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M15.306 14.461l-3.32-3.1-3.3 3.1a1.002 1.002 0 01-1.37-1.46l4-3.73a1.002 1.002 0 011.37 0l4 3.73a1.001 1.001 0 01-.7 1.73.993.993 0 01-.68-.27z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}

export function checkmarkLg(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M9.29 18.72a.87.87 0 01-.637.28.87.87 0 01-.637-.28l-4.84-5.11a.987.987 0 01.092-1.239.862.862 0 011.174-.079l4.202 4.437L19.598 5.163a.861.861 0 011.12.096c.306.304.37.793.155 1.175L9.291 18.72z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}

export function checkmarkSm(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M11.428 15.678c-.417.43-1.078.43-1.495 0L7.438 13.16a1.182 1.182 0 01-.42-1.128c.073-.43.371-.778.767-.896.396-.119.82.014 1.094.341l1.72 1.775 4.55-4.9a1.034 1.034 0 011.035-.317c.373.099.668.402.774.796a1.2 1.2 0 01-.26 1.112l-5.27 5.736z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}

export function closeLg(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M11.999 10.668l5.392-5.392a.944.944 0 011.334 1.334L13.333 12l5.389 5.39a.943.943 0 11-1.334 1.333L12 13.335 6.614 18.72a.944.944 0 01-1.334-1.334l5.385-5.385-5.388-5.387A.944.944 0 016.611 5.28l5.388 5.388z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}

export function closeSm(color: string, size: string) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={checkSize(size)}
      height={checkSize(size)}
      viewBox="0 0 24 24"
      aria-hidden="true"
    >
      <path
        d="M13.513 12.043l2.272-2.275a1.08 1.08 0 00-.1-1.41 1.08 1.08 0 00-1.408-.1l-2.315 2.233-2.24-2.275c-.428-.322-1.028-.28-1.407.1s-.421.98-.1 1.41l2.283 2.317-2.272 2.232a1.078 1.078 0 001.508 1.51l2.228-2.286 2.272 2.275a1.077 1.077 0 001.508-1.51l-2.23-2.22z"
        fill={checkColor(color)}
        fillRule="nonzero"
      />
    </svg>
  );
}
